module.exports = __webpack_public_path__ + "static/img/jnsx-tl.91a15bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jnsx-tl.png
// module id = J132
// module chunks = 1